import {
    CREATEFINDINGCATEGORY,
    GETFINDINGCATEGORY,
    UPDATEFINDINGCATEGORY,
    DELETEFINDINGCATEGORY,
    CREATEFINDING,
    GETFINDING,
    UPDATEFINDING,
    DELETEFINDING,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEFINDINGCATEGORY:
            return {
                ...state,
                findingcategorySaveStatus: action.payload.success,
            }
        case GETFINDINGCATEGORY:
                return {
                        ...state,
                        findingcategoryList: action.payload.data,
                        }
        case UPDATEFINDINGCATEGORY:
                return {
                        ...state,
                        findingcategoryUpdateStatus: action.payload.success,
                        }   

        case DELETEFINDINGCATEGORY:
                 return {
                     ...state,
                     findingcategoryDeleteStatus: action.payload.success,
                        } 
        case CREATEFINDING:
            return {
                ...state,
                findingSaveStatus: action.payload.success,
            }
        case GETFINDING:
                return {
                        ...state,
                        findingList: action.payload.data,
                        }
        case UPDATEFINDING:
                return {
                        ...state,
                        findingUpdateStatus: action.payload.success,
                        }   

        case DELETEFINDING:
                 return {
                     ...state,
                     findingDeleteStatus: action.payload.success,
                        } 
        default:
                return state
                      }
                 }